export default __webpack_public_path__ + "img/subscription_border-c25ab2d2c0690a2cb05b46d7813cb106.png";